import { URLS } from '../../../constants';
import apiClient from '../../client';

const clientInvoiceAPI = {
  clientInvoice: ({
    payloadOrganizationId,
    payloadUserId,
    sorting,
  }: {
    payloadOrganizationId: any;
    payloadUserId: any;
    sorting: any;
  }) =>
    apiClient.post(URLS.clientInvoice, {
      data: {
        payloadOrganizationId,
        payloadUserId,
        sorting,
      },
    }),
};
export default clientInvoiceAPI;
